<template>
	<div class="c-filter-newsroom-event--newsboard" data-css="c-filter-newsroom-event">
		<div class="filter-newsroom-event__block">
			<div class="filter-newsroom-event__area" data-js-item="js-filter-newsroom-event-area">
				<slot name="toolbar">
					<span></span>
				</slot>
			</div>
			<slot name="active-zone">
				<span></span>
			</slot>
		</div>
	</div>
</template>
